import { getToken, getMealDetail, getQrcode } from 'services/meal';
import { getMealNetworkDetail, getMealProDetail } from 'services';
import router from 'umi/router';
// import { getUrlParam } from 'utils/getValue';

function* handleRequest(res, put) {
  const { state, note, data } = res.data;
  const errMsg = state !== '11' ? note : '';
  let result = data;
  if (state !== '11') {
    result = null;
  }

  yield put({
    type: 'setData',
    payload: { errMsg },
  });
  return state !== '11' ? false : result;
}

export default {
  namespace: 'meal',
  state: {
    detail: {}, // 饭票详情
    qrCode: '', // 二维码
    brCode: '', // 条形码
    errMsg: '',
    mealList: [],
    mealDetail: {},
  },
  effects: {
    *getToken({ payload, callback }, { call, put }) {
      const response = yield call(getToken, payload);
      const data = yield handleRequest(response, put);
      if (!data) return;
      // 登录操作
      const { token, redirectPage, cacheSeconds } = data;
      localStorage.setItem('token', `Bearer ${token}`);
      localStorage.setItem('tokenExprieTimer', cacheSeconds);
      if (redirectPage) {
        const hasHttp = redirectPage.indexOf('http') !== -1;
        if (hasHttp) {
          window.location.replace(redirectPage);
          return;
        }
        router.replace({
          pathname: payload.redirectUrl,
        });
        return;
      }
      callback && callback();
    },
    *getMealDetail({ payload, callback }, { call, put }) {
      const response = yield call(getMealDetail, payload);
      const data = yield handleRequest(response, put);
      if (!data) return;
      yield put({
        type: 'setData',
        payload: { detail: data, qrCode: data.base64QrCode, brCode: data.base64BarCode },
      });
      callback && callback(data);
    },
    *getQrcode({ payload, callback }, { call, put }) {
      const response = yield call(getQrcode, payload);
      const data = yield handleRequest(response, put);
      if (!data) return;
      yield put({
        type: 'setData',
        payload: { qrCode: data },
      });

      callback && callback();
    },
    *queryNetworkDetail({ payload }, { call, put }) {
      const response = yield call(getMealNetworkDetail, payload);
      if (response.data.state === '11') {
        //return response.data.data;
        yield put({
          type: 'setData',
          payload: {
            mealList: response.data.data,
          },
        });
      }
      return [];
    },
    *queryMealDetail({ payload }, { call, put }) {
      const response = yield call(getMealProDetail, payload);
      if (response.data.state === '11') {
        yield put({
          type: 'setData',
          payload: {
            mealDetail: response.data.data,
          },
        });
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
